import React, {Component} from 'react';
import {Modal, Form, Input, InputNumber, Select, Button} from 'antd';
import authorizeBase from "../../components/authorize/authorizeBase";
const AuthButton = authorizeBase(Button)
const {Option} = Select;

const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
};
class PackageModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key: 0,
            packageKindData: [{
                name: 'Container'
            }, {
                name: 'Pallet'
            }],
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (err) {
                return;
            } else {
                const {saveData, updateKey} = this.props;
                //getFieldsValue() 获取表单中输入的值
                const {getFieldsValue, resetFields} = this.props.form;
                const values = getFieldsValue();
                if (values.netWeight === '' || values.netWeight === null || values.netWeight === undefined) {
                    values.netWeight = values.grossWeight
                }
                console.log(values)
                //antd table需要加一个key字段
                this.setState({
                    key: updateKey,
                });
                values.key = updateKey;
                saveData(values);
                this.handleCancel()
            }
        });
    };
    handleCancel = () => {
        this.props.hideModal();
        this.props.form.resetFields();
    };

    render() {
        const {editVisiable} = this.props;
        // getFieldDecorator用于定义表单中的数据
        const {getFieldDecorator} = this.props.form;
        return (
            <Modal
                visible={ editVisiable }
                onCancel={ this.handleCancel }
                onOk={ this.handleOk } footer={[
                <Button key="back" onClick={this.handleCancel}>
                    取消
                </Button>,
                <AuthButton authority="pack_edit:save" key="submit" type="primary" onClick={this.handleOk}>
                    确定
                </AuthButton>,
            ]}>
                <Form {...formItemLayout}>
                    <Form.Item>
                        {getFieldDecorator('id', {
                        })(<Input type={'hidden'}/>)}
                    </Form.Item>
                    <Form.Item label="客户单号">
                        {getFieldDecorator('platOrderNo', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="大区">
                        {getFieldDecorator('area', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="客户简称">
                        {getFieldDecorator('customerName', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="随箱编号">
                        {getFieldDecorator('boxNo', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="运单号">
                        {getFieldDecorator('deliveryNo', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="集装箱号">
                        {getFieldDecorator('containerNo', {rules: [{required: true, message: '该项必填',},],})(<Input />)}
                    </Form.Item>
                    <Form.Item label="报关类型">
                        {getFieldDecorator('declareType', {rules: [{required: true, message: '该项必填',},],})
                        (<Select>
                            <Option value="寄售代销">寄售代销</Option>
                            <Option value="一般贸易">一般贸易</Option>
                            <Option value="零售小包">零售小包</Option>
                            <Option value="保税出口">保税出口</Option>
                            <Option value="通关一体化">通关一体化</Option>
                            <Option value="转关运输">转关运输</Option>
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="箱数CTNS">
                        {getFieldDecorator('num', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber />)}
                    </Form.Item>
                    <Form.Item label="总重量(Kg)">
                        {getFieldDecorator('grossWeight', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01} suffix="kg"/>)} kg
                    </Form.Item>
                    <Form.Item label="净重(Kg)">
                        {getFieldDecorator('netWeight', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01} suffix="kg"/>)} kg
                    </Form.Item>
                    <Form.Item label="尺寸">
                        {getFieldDecorator('size', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="体积(CBM)">
                        {getFieldDecorator('volume', {
                            // rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01} suffix="CBM"/>)} CBM
                    </Form.Item>
                    <Form.Item label="品名(中文)">
                        {getFieldDecorator('name', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="品名(英文)">
                        {getFieldDecorator('nameEn', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="国内HSCode">
                        {getFieldDecorator('hscode', {
                            rules: [{required: true,max:10, message: '该项必填且最多10个字符'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="国外HSCode">
                        {getFieldDecorator('oHscode', {
                            //rules: [{max:10, message: '该项最多10个字符'}]
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="数量PCS">
                        {getFieldDecorator('pcsNumber', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber />)}
                    </Form.Item>
                    <Form.Item label="单件净重">
                        {getFieldDecorator('unitNetWeight', {
                            // rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01}/>)}
                    </Form.Item>
                    <Form.Item label="单价">
                        {getFieldDecorator('originalValue', {
                            rules: [{required: true, message: '该项必填',},],
                        })(<InputNumber precision={2} step={0.01}/>)}
                    </Form.Item>
                    <Form.Item label="币制">
                        {getFieldDecorator('originalCurrency', {
                            initialValue: 'USD',
                        })(<Select>
                            <Option value="USD">USD</Option>
                            <Option value="EUR">EUR</Option>
                            <Option value="GBP">GBP</Option>
                        </Select>)}
                    </Form.Item>
                    <Form.Item label="成分(备注比例)">
                        {getFieldDecorator('ingredient', {
                            // rules: [{required: true, message: '该项必填',},],
                        })(<Input />)}
                    </Form.Item>
                    <Form.Item label="用途">
                        {getFieldDecorator('application', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="链接">
                        {getFieldDecorator('picUrl', {})(<Input />)}
                    </Form.Item>
                    <Form.Item label="品牌">
                        {getFieldDecorator('brand', {})(<Input />)}
                    </Form.Item>
                </Form>
            </Modal>
        );
    }

}

const WrapPackageModel = Form.create()(PackageModel)
export default WrapPackageModel